var map = {
	"./all.svg": 39875,
	"./art.svg": 98679,
	"./beauty-spas.svg": 39954,
	"./entertainment.svg": 27232,
	"./evacuation-center.svg": 84504,
	"./health-care.svg": 69720,
	"./polling-place.svg": 99231,
	"./public-places.svg": 19049,
	"./restaurant.svg": 28897,
	"./shop.svg": 88149,
	"./toilet.svg": 28173,
	"./tourist-attraction.svg": 44426,
	"./transportation.svg": 43950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3530;